import { css, styled, Typography } from '@mui/material';

import { FCWithChildren, IWithClassName, IWithDynamicTag } from '/common/models';

export interface IStyledTextProps extends IWithDynamicTag, IWithClassName {}

export const TextComponent: FCWithChildren<IStyledTextProps> = ({ as: Component = 'span', children, className }) => {
  return <Component className={className}>{children}</Component>;
};

export const TextSecondary = styled(TextComponent)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;
export const TypographyMode = styled(Typography)`
  color: ${({ theme }) => (theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.text.primary)};
`;
export const TypographyGrey = styled(Typography)`
  color: ${({ theme }) => (theme.palette.mode === 'light' ? theme.palette.grey[800] : theme.palette.text.primary)};
`;

export const TextDisabled = styled(TextComponent)`
  color: ${({ theme }) => theme.palette.text.disabled};
`;

export const ErrorWrapper = styled('div')(({ theme }) => ({
  color: theme.palette.error.main,
}));

export const JSON_TEXT_FONT_FAMILY = 'Menlo, Monaco, "Courier New", monospace';

export const jsonTextCSS = css`
  font-family: ${JSON_TEXT_FONT_FAMILY};
  font-size: 0.75rem;
  line-height: 1rem;
`;
